import { useState } from "react";

export const faqs = [
  { q: "How fast can I get a passport in Pearl?", a: "We offer processing as fast as 24 hours for emergency situations. For routine expedited service, expect 3–5 business days. Standard expedited is 7–10 business days." },
  { q: "Where is the closest passport acceptance facility to Pearl?", a: "The Pearl Post Office at 1300 Highway 80 E is a USPS passport acceptance facility. The Rankin County Chancery Clerk in Brandon also offers services. However, for expedited service, we handle everything remotely." },
  { q: "Do you serve the entire Rankin County area?", a: "Yes. We serve Pearl, Flowood, Brandon, Richland, and all surrounding Rankin County communities. Our service is fully remote regardless of your location." },
  { q: "Can I renew my passport without visiting an office?", a: "If your current passport was issued within the last 15 years and you were 16 or older at the time, you can renew by mail without an office visit. We handle the expedited courier submission." },
  { q: "What do I need for a child passport?", a: "For minors under 16, both parents must appear with the child at a passport acceptance facility (or provide notarized consent), along with proof of citizenship, ID, and a passport photo." },
  { q: "Is your service cheaper than FedEx or Staples?", a: "Yes. As a registered U.S. Department of State courier — not a reseller — we offer rates typically 30–100% lower than third-party resellers like FedEx, Staples, or UPS." },
  { q: "Can I get a same-day passport in Pearl?", a: "For documented life-or-death emergencies or imminent international travel via Jackson-Medgar Wiley Evers Airport, our emergency service processes passports as fast as 24 hours. Call 877-253-0084 to verify eligibility." },
  { q: "Do you serve the Jackson metro area from Pearl?", a: "Yes. We serve Pearl, Flowood, Brandon, Richland, Jackson, Clinton, Ridgeland, Madison, and all greater Jackson metro communities with the same expedited mail-in process." },
];

export default function PearlFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Pearl Passport <span className="text-[#F6C344]">Questions</span>
          </h2>
        </div>
        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`text-white text-sm transition-transform duration-200 ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a href="tel:8772530084" className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap">
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}